"use strict";

$(
	function() {
		appMobile.initializeMobile();
		if (appMobile.isMobileMode()) {
			$("div._").addClass('mobile-version');
		}
		appMobile.setWinSize();
		appMobile.mobileResizeCorrection();
		$(window).resize(
			function() {
				if (!appMobile._mobileIsInitialized && $(window).width() <= 760) {
					setTimeout(
						function() {
							appMobile.initializeMobile();
						},
						300
					)
				}
				appMobile.setWinSize();
				appMobile.mobileResizeCorrection();
			}
		);
	}
);

var appMobile = {
	_vars: {
		v: '1.0.1'
	},
	_menuBarInitialized: false,
	_mobileIsInitialized: false,
	setWinSize: function () {
		app.createCookie('winWidth', $(window).width());
	},
	isMobileMode: function () {
		this.initializeMobile();
		/*mobile version V2*/
		if (this.version() > 1) {
			return true;
		}
		var $mobMenu = $('.mobile-top-menu');
		if ($mobMenu.length === 0) {
			return false;
		}
		/*mobile version V1*/
		return $mobMenu.css('display') !== 'none';
	},
	version: function() {
		try {
			if (app.getClassColor && app.getClassColor('mob-mode-identifier-v2').indexOf('255') > 0) {
				return 2;
			}
		} catch(e) {

		}
		return 1;
	},
	mobileResizeCorrection: function () {
		var that = this;
		var $cartTable = $('.cart table.list, table.ch-prod-list, table.udu__prod-list-pay-methods');
		if (!this.isCorrected($cartTable)) {
			var isCartTable = $cartTable.find('form').length >= 1;
			$cartTable.find('tr').each(
				function () {
					if (isCartTable) {
						var $tdImg = $(this).find('td.image');
						var html1 = $(this).find('td.description').html();
						var html2 = $(this).find('td.quantity').html();
						$tdImg.append('<div class="mob-visible mob-only udu__mob-items-v2"><div class="desc">' + html1 +
							'</div><div class="qnt">' + html2 + '</div></div>');
						$tdImg.find('.mob-only button').each(
							function () {
								var tlt = $(this).attr('title');
								if (tlt) {
									$(this).append('<span class="mob-cap">' + tlt + '</span>');
								}
							}
						);
						if (app.events) {
							app.events.trigger(
								'udu_MOBILE-APPLIED-TO-CART-TABLE',
								{
									$td: $tdImg
								}
							)
						}
					} else {
						$tdImg = $(this).find('td.image');
						html1 = $(this).find('td.description').html();
						html2 = $(this).find('.unit-price').html();
						$(this).find('.quantity').append(that.mobOnly(html2));
						$tdImg.append('<div class="mob-visible mob-only udu__mob-items-v2"><div class="desc">' + html1 + '</div></div>');
						$tdImg.find('.mob-only button').each(
							function () {
								var tlt = $(this).attr('title');
								if (tlt) {
									$(this).append('<span class="mob-cap">' + tlt + '</span>');
								}
							}
						);
					}
                    $tdImg.find('.prod-cart-description').remove();
                    if (app.events) {
                        app.events.trigger(
                            'udu_MOBILE-APPLIED-TO-CART-TABLE',
                            {
                                $td: $tdImg
                            }
                        )
                    }
				}
			);
		}
		var $shipMethods = $('.mob-support table.shipping-methods');
		if (!this.isCorrected($shipMethods)) {
			$shipMethods.find('tr').each(
				function () {
					$(this).find('.option').append(that.mobOnly($(this).find('.delivery-date'), 'mob-min'));
				}
			);
		}

		var $myBudgetTable = $('.mob-support table.budgets-list');
		if (!this.isCorrected($myBudgetTable)) {
			$myBudgetTable.find('tr').each(
				function () {
					$(this).find('.limit').append(that.mobOnly($(this).find('.amountSpent'), 'mob-min'));
					$(this).find('.dateStart').append(that.mobOnly($(this).find('.dateEnd'), 'mob-min'));
					$(this).find('.description').append(that.mobOnly($(this).find('.costCenter'), 'mob-min'));
				}
			);
		}

		var $avgBudgetTable = $('.mob-support table.avl-budgets');
		if (!this.isCorrected($avgBudgetTable)) {
			$avgBudgetTable.find('tr').each(
				function () {
					$(this).find('th:nth-child(1)').append(that.mobOnly($(this).find('th:nth-child(2)'), 'mob-min'));
					$(this).find('th:nth-child(1)').append(that.mobOnly($(this).find('th:nth-child(5)')));
					$(this).find('th:nth-child(6)').append(that.mobOnly($(this).find('th:nth-child(7)')));
					$(this).find('th:nth-child(6)').append(that.mobOnly($(this).find('th:nth-child(8)'), 'mob-min'));
					$(this).find('td.description').append(that.mobOnly($(this).find('td.costCenter'), 'mob-min'));
					$(this).find('td.description').append(that.mobOnly($(this).find('td.approvers')));
					$(this).find('td.limit').append(that.mobOnly($(this).find('td.amountSpent')));
					$(this).find('td.limit').append(that.mobOnly($(this).find('td.balance'), 'mob-min'));
				}
			);
		}

		var $budgetTable = $('.mob-support .budget-ord-list table:not(.tbl-order-history)');
		if (!this.isCorrected($budgetTable)) {
			$budgetTable.find('tr').each(
				function () {
					$(this).find('th:nth-child(1)').append(that.mobOnly($(this).find('th:nth-child(2)'), 'mob-avr'));
					$(this).find('th:nth-child(5)').append(that.mobOnly($(this).find('th:nth-child(3)')));
					$(this).find('th:nth-child(1)').append(that.mobOnly($(this).find('th:nth-child(5)')));
					$(this).find('th:nth-child(9)').append(that.mobOnly($(this).find('th:nth-child(10)')));
					$(this).find('th:nth-child(9)').append(that.mobOnly($(this).find('th:nth-child(11)')));
					$(this).find('td.customerName').append(that.mobOnly($(this).find('td.companyName'), 'mob-avr'));
					$(this).find('td.budget-description').append(that.mobOnly($(this).find('td.created')));
					$(this).find('td.customerName').append(that.mobOnly($(this).find('td.budget-description')));
					$(this).find('td.budget-spendingAmount').append(that.mobOnly($(this).find('td.budget-allowedOverspendingAmount')));
					$(this).find('td.budget-spendingAmount').append(that.mobOnly($(this).find('td.budget-spenderAmountSpent')));
					$(this).find('td.budget-view-order').append(that.mobOnly($(this).find('td.orderTotal')));
				}
			);
		}
		var $ordHistTable = $('table.tbl-order-history');
		if (!this.isCorrected($ordHistTable)) {
			$ordHistTable.find('tr').each(
				function () {
					$(this).find('.ord-id').append(that.mobOnly($(this).find('.ord-date')));
					$(this).find('.comp-name').append(that.mobOnly($(this).find('.last-name').html() + ',<br/>' + $(this).find('.first-name').html()));
				}
			);
		}
		this.createMobileSlider();
	},
	createMobileSlider: function () {
		if (app._vars.noCreateMobileSlider) {
			return this;
		}
		if (app.iniIndexSliderHTML && $('.mob-nivoSlider').length === 0) {
			var $div = $('.li-nivo-wrapper');
			if ($div.length === 0) {
				$div = $('.slider-wrapper');
			}
			var that = this;
			$div.each(
				function() {
					var $this = $(this);
					var id = $this.find('.nivoSlider ').attr('id');
					if (app._vars._iniIndexSlidersHTML && app._vars._iniIndexSlidersHTML[id]) {
						var html = app._vars._iniIndexSlidersHTML[id];
					} else {
						html = app.iniIndexSliderHTML;
					}

					if (that.version() === 2) {
						html = html.replace(/<a/g, '<li><a')
							.replace(/<\/a>/g, '</a></li>');
						html = '<ul class="rslides mob-nivoSlider mob-only">' + html + '</ul>';
						html = html.replace(/id="[^"]+"/g, '');
					} else {
						html = "<div style='display:none' class=\"mob-nivoSlider\">" + html + "</div>";
					}
					$(html).insertBefore($this);
				}
			)


		}
		var $mobSlider = $(".mob-nivoSlider.rslides");
		if (this.version() === 2 && !$mobSlider.hasClass('slider-done')) {
			$mobSlider.addClass('slider-done');
			app.getScript('responsiveslides.min.js',
				function(){
					$(".mob-nivoSlider.rslides").responsiveSlides({
						maxwidth: 800,
						speed: 800
					});
				}
			);
		}

		if (app.iniCaruselHTML && $('.mob-carousel').length === 0) {
			var html = '<ul style="display:none" class="mob-carousel">' + app.iniCaruselHTML + '</ul>';
			$(html).insertBefore('.index-slider');
		}
	},
	isCorrected: function ($item) {
		if ($item.length > 0 && $item.data('mobileCorrectionData') !== 'Y') {
			$item.data('mobileCorrectionData', 'Y');
			return false;
		}
		return true;
	},
	mobOnly: function (html, addClass) {
		if (!html) {
			return '';
		}
		if (typeof html == 'object') {
			html = html.html();
		}
		if (!addClass) {
			addClass = '';
		}
		return '<span class="mob-visible mob-only ' + addClass + '">' + html + '</span>';
	},
	initializeMobile: function () {
		if (this._mobileIsInitialized || $(window).width() > 760) {
			return false;
		}

		this._mobileIsInitialized = true;

		// for new versions we do not use top black many anymore
		if (app._VERSION >= 2) {
			return false;
		}

		var $myAccount = $("a.my-account");
		var $aLang = $("a.lang");
		var $aLogOut = $("a.log-out");
		var $shForm = $('form.search-form');
		var $aCrcy = $('a.currency');
		var $aLogIn = $("a.log-in");

		if (!window.admin) {
			$('body').css('overflow-x', 'hidden');
		}

		if (appMobile._menuBarInitialized) {
			return;
		}

		appMobile._menuBarInitialized = true;

		var $prod = $('._ .product-list2 div.item');
		if ($prod.length > 0) {
			$('._ .product-list2').addClass('prodCnt-' + $prod.length);
		}
        if (app.accessHiddenItems) {
            $(app.accessHiddenItems).remove();
        }
		if (this.version() === 2) {
			var menuHtml = $('div.menu ul').html();
			if (!menuHtml) {
				menuHtml = '';
                $('div.menu a').each(
                	function() {
                		var href = $(this).attr('href');
                		if (href) {
                            menuHtml += '<li><a href="' + $(this).attr('href') + '">' + $(this).html() + '</a></li>';
						} else {
                            menuHtml += '<li><a>' + $(this).html() + '</a></li>';
						}
					}
				);
			}

			var $budgLink = $('.my-budgets.single > a');
			if ($budgLink.length >= 1) {
                menuHtml = '<li><a href="' + $budgLink.attr('href') + '">' + $budgLink.html() + '</a></li>' + menuHtml;
			}
			var mobMenuOpened = '';
			if (app.createMobileMenuOpened) {
				mobMenuOpened = 'opened';
			}
			menuHtml = '<div class="li-block mob-only mob-menu ' + mobMenuOpened + '"><h3><span>Menu</span></h3><ul>' + menuHtml + '</ul></div>';
			var $d2 = $('.main .d2');
            menuHtml = menuHtml.replace(/ul-mega-/g, 'ul-mob-mega-');
			if ($d2.length === 1) {
				$d2.prepend(menuHtml);
			} else {
				$($('.main .center-part')[0]).prepend('<div class="d2">' + menuHtml + '</div>');
			}

            $('.mob-menu .with-children .top-title a').click(
            	function() {
                    $(this).closest('li').toggleClass('sub-opened');
            		return false;
				}
			);

			var mobMenuFontSize = $('.mob-menu .top-title > a').css('font-size');
			if (mobMenuFontSize) {
                $('.mob-menu .ul-mega-1 a').attr('style', 'font-size:' + mobMenuFontSize + ' !important');
			}
			var $mobMenu = $('.mob-menu');
			if ($mobMenu.find('a').length === 0) {
                $mobMenu.remove();
			}
			$('.li-block h3').click(
				function() {
					var $this = $(this);
					var $blk = $this.closest('div.li-block');
					if (!$blk.hasClass('opened')) {
						$blk.addClass('opened');
					} else {
						$blk.removeClass('opened');
					}
					app.events.trigger(
						'udu-MOBILE-MENU-SWITCH',
						{
							$h3: $this,
							$blk: $blk
						}
					)
				}
			);

			$('.mob-menu.li-block .div-search-field, .mob-menu.li-block .my-cart')
				.closest('li')
				.remove();

			var $menuSearch = $('div.menu .div-search-field:not(.sku), .search-place .div-search-field:not(.sku), div.my-cart .div-search-field:not(.sku), .my-cart-line .div-search-field:not(.sku)');
			if ($menuSearch.length >= 1) {
				$('div.menu').before(
					'<div class="mob-add-quick-search mob-only">' + $menuSearch.closest('li').html() + '</div>'
				);
			}
		}

		var html = '<div class="mobile-top-menu"><ul><li><a class="home"></a></li>';

		if ($aLogOut.length > 0) {
			html += '<li class="right mob-log-out"><a></a></li>';
		}
		if ($aLang.length > 0) {
			html += '<li class="right"><a class="mob-lang"></a></li>';
		}
		if ($("a.reg-me").length > 0) {
			html += '<li class="right"><a class="mob-register"></a></li>';
		}
		if ($myAccount.length > 0) {
			html += '<li class="right"><a class="mob-register mob-account"></a></li>';
		}
		if ($aLogIn.length > 0) {
			html += '<li class="right"><a class="mob-login"></a></li>';
		}
		if ($("a.cart").length > 0) {
			html += '<li class="right"><a class="mob-cart"></a></li>';
		}
		if ($aCrcy.length > 0) {
			html += '<li class="right"><a class="mob-currency"></a></li>';
		}
		if ($shForm.length > 0 || (app.mobileOptions && app.mobileOptions.showSearch)) {
			html += '<li class="right"><a class="mob-search"></a></li>';
		}

		html += '</ul></div>';

		if ($("._ .d2").length > 0) {
			html += '<div class="mob-slide" onclick="appMobile.showHideLeftMenu()"><a></a></div>';
		}

		$(html).appendTo('body');

        if (app.doAfterMobileInitialized) {
            app.doAfterMobileInitialized();
		}

		$('.mobile-top-menu .home').prop('href', $('a.logo').prop('href'));

		if ($myAccount.length > 0) {
			$('.mobile-top-menu .mob-register').prop('href', $myAccount.prop('href'));
		} else {
			$('.mobile-top-menu .mob-register').prop('href', $('a.reg-me').prop('href'));
		}

		if ($aLogIn.length > 0) {
            $('.mobile-top-menu .mob-login').prop('href', $aLogIn.prop('href'));
		}

		var $mobLang = $('.mobile-top-menu .mob-lang').prop('href', $aLang.prop('href'));
		if (app.getLang() === 'fr') {
			$mobLang.addClass('en');
		}
		$('.mobile-top-menu .mob-cart').prop('href', $('a.cart').prop('href'));
		$('.mobile-top-menu .mob-search').prop('href', $shForm.prop('action'));
		$('.mobile-top-menu .mob-currency').prop('href', $aCrcy.prop('href'));
		$('.mobile-top-menu .mob-log-out a').prop('href', $aLogOut.prop('href'));

		if (app.mobileOptions && app.mobileOptions.searchURL) {
			$('.mobile-top-menu .mob-search').prop('href', app.mobileOptions.searchURL);
		}

		$('.menu > ul > li.with-children > div > a, .menu > ul > li.with-children > div > .delimiter').click(
			function(e) {
				if (app.isMobile()){
					var $li = $(this).closest('li');
					if ($li.hasClass('mob-open')) {
						$li.removeClass('mob-open');
					} else {
						$li.addClass('mob-open');
					}
					e.preventDefault();
				}
			}
		);
		if (!appMobile.isMobileMode()) {
			return;
		}

		// mobile JS is here
		setTimeout(
			function () {
				$(".mob-slide").animate(
					{
						left: -4
					},
					1000
				)
			},
			1000
		);

		// correct long Price tables
		$('table.price-table').each(
			function () {
				var thCount = $(this).find('th').length;
				if (thCount < 5) {
					return;
				}

				var html = $(this).html();
				$(this).addClass('clone-1');
				var duplicateCount = Math.ceil((thCount - 1) / 3);
				for (var i = duplicateCount; i > 1; i--) {
					$('<table class="price-table clone-' + i + ' tbl-bordered price-table-m">' + html + '</table>')
						.insertAfter(this)
				}
			}
		);

		for (var i = 1; i < 20; i++) {
			var tbl = $('table.clone-' + i);
			if (tbl.length === 0) {
				break;
			}
			tbl.find('td, th').addClass('remove');
			tbl.find('td:first-child, th:first-child').removeClass('remove');
			for (var x = 2; x < 5; x++) {
				var tmp = ((i - 1) * 3 + x);
				tbl.find('td:nth-child(' + tmp + ')').removeClass('remove').addClass('mob-td-price');
				tbl.find('th:nth-child(' + tmp + ')').removeClass('remove').addClass('mob-td-price');
			}
			tbl.find('td.remove, th.remove').css('display', 'none');
		}

		$("table.list").css('visibility', 'visible');
	},

	showHideLeftMenu: function () {
		appMobile.blockWindow(true);
		$(".mob-slide").animate(
			{
				left: -74
			},
			500,
			function () {
				setTimeout(
					function () {
						var $d2 = $("._ .d2");
						var $modSlide = $(".mob-slide");
						if (!$d2.hasClass('mob-visible')) {
							$d2.addClass('mob-visible').removeClass('mob-invisible');
							$("._ .d1").addClass('mob-invisible').removeClass('mob-visible');
							$modSlide.addClass('right-arrow');
						} else {
							$d2.addClass('mob-invisible').removeClass('mob-visible');
							$("._ .d1").addClass('mob-visible').removeClass('mob-invisible');
							$modSlide.removeClass('right-arrow');
						}
						$('body,html').animate({
							scrollTop: 0
						}, 500);
						appMobile.blockWindow(false);
						$modSlide.animate(
							{
								left: -4
							},
							500
						);
					},
					400
				)
			}
		)
	},

	blockWindow: function (doBlock) {
		if ($("#div-block").length === 0) {
			$("<div id=\"div-block\"></div>").appendTo('body, html');
		}
		if (doBlock) {
			$("#div-block").css('display', 'block').fadeTo(0, 0).fadeTo(400, 0.6);
		} else {
			$("#div-block").css('display', 'block')
				.fadeTo(
				200,
				0,
				function () {
					$("#div-block").hide();
				}
			)
		}
	}
};